export enum RankBadgeVariant {
  Worst = 'worst',
  Best = 'best',
  Actual = 'actual',
}

export type Rank = 1 | 2 | 3 | 4 | 5;

export type RankBadgeStyle = { color: string; opacity: number; };

export interface RowBorderRadiusConfig {
  top?: boolean;
  bottom?: boolean;
}

export interface WithBorderRadiusConfig {
  borderRadiusConfig?: RowBorderRadiusConfig;
}
